export const CURRENCY_CODES = t => [
  { value: 'AFN', label: t('currency.afn') },
  { value: 'EUR', label: t('currency.eur') },
  { value: 'ALL', label: t('currency.all') },
  { value: 'DZD', label: t('currency.dzd') },
  { value: 'USD', label: t('currency.usd') },
  { value: 'AOA', label: t('currency.aoa') },
  { value: 'XCD', label: t('currency.xcd') },
  { value: 'XAD', label: t('currency.xad') },
  { value: 'ARS', label: t('currency.ars') },
  { value: 'AMD', label: t('currency.amd') },
  { value: 'AWG', label: t('currency.awg') },
  { value: 'AUD', label: t('currency.aud') },
  { value: 'AZN', label: t('currency.azn') },
  { value: 'BSD', label: t('currency.bsd') },
  { value: 'BHD', label: t('currency.bhd') },
  { value: 'BDT', label: t('currency.bdt') },
  { value: 'BBD', label: t('currency.bbd') },
  { value: 'BYN', label: t('currency.byn') },
  { value: 'BZD', label: t('currency.bzd') },
  { value: 'XOF', label: t('currency.xof') },
  { value: 'BMD', label: t('currency.bmd') },
  { value: 'INR', label: t('currency.inr') },
  { value: 'BTN', label: t('currency.btn') },
  { value: 'BOB', label: t('currency.bob') },
  { value: 'BOV', label: t('currency.bov') },
  { value: 'BAM', label: t('currency.bam') },
  { value: 'BWP', label: t('currency.bwp') },
  { value: 'NOK', label: t('currency.nok') },
  { value: 'BRL', label: t('currency.brl') },
  { value: 'BND', label: t('currency.bnd') },
  { value: 'BGN', label: t('currency.bgn') },
  { value: 'BIF', label: t('currency.bif') },
  { value: 'CVE', label: t('currency.cve') },
  { value: 'KHR', label: t('currency.khr') },
  { value: 'XAF', label: t('currency.xaf') },
  { value: 'CAD', label: t('currency.cad') },
  { value: 'KYD', label: t('currency.kyd') },
  { value: 'CLP', label: t('currency.clp') },
  { value: 'CLF', label: t('currency.clf') },
  { value: 'CNY', label: t('currency.cny') },
  { value: 'COP', label: t('currency.cop') },
  { value: 'COU', label: t('currency.cou') },
  { value: 'KMF', label: t('currency.kmf') },
  { value: 'CDF', label: t('currency.cdf') },
  { value: 'NZD', label: t('currency.nzd') },
  { value: 'CRC', label: t('currency.crc') },
  { value: 'CUP', label: t('currency.cup') },
  { value: 'XCG', label: t('currency.xcg') },
  { value: 'CZK', label: t('currency.czk') },
  { value: 'DKK', label: t('currency.dkk') },
  { value: 'DJF', label: t('currency.djf') },
  { value: 'DOP', label: t('currency.dop') },
  { value: 'EGP', label: t('currency.egp') },
  { value: 'SVC', label: t('currency.svc') },
  { value: 'ERN', label: t('currency.ern') },
  { value: 'SZL', label: t('currency.szl') },
  { value: 'ETB', label: t('currency.etb') },
  { value: 'FKP', label: t('currency.fkp') },
  { value: 'FJD', label: t('currency.fjd') },
  { value: 'XPF', label: t('currency.xpf') },
  { value: 'GMD', label: t('currency.gmd') },
  { value: 'GEL', label: t('currency.gel') },
  { value: 'GHS', label: t('currency.ghs') },
  { value: 'GIP', label: t('currency.gip') },
  { value: 'GTQ', label: t('currency.gtq') },
  { value: 'GBP', label: t('currency.gbp') },
  { value: 'GNF', label: t('currency.gnf') },
  { value: 'GYD', label: t('currency.gyd') },
  { value: 'HTG', label: t('currency.htg') },
  { value: 'HNL', label: t('currency.hnl') },
  { value: 'HKD', label: t('currency.hkd') },
  { value: 'HUF', label: t('currency.huf') },
  { value: 'ISK', label: t('currency.isk') },
  { value: 'IDR', label: t('currency.idr') },
  { value: 'XDR', label: t('currency.xdr') },
  { value: 'IRR', label: t('currency.irr') },
  { value: 'IQD', label: t('currency.iqd') },
  { value: 'ILS', label: t('currency.ils') },
  { value: 'JMD', label: t('currency.jmd') },
  { value: 'JPY', label: t('currency.jpy') },
  { value: 'JOD', label: t('currency.jod') },
  { value: 'KZT', label: t('currency.kzt') },
  { value: 'KES', label: t('currency.kes') },
  { value: 'KPW', label: t('currency.kpw') },
  { value: 'KRW', label: t('currency.krw') },
  { value: 'KWD', label: t('currency.kwd') },
  { value: 'KGS', label: t('currency.kgs') },
  { value: 'LAK', label: t('currency.lak') },
  { value: 'LBP', label: t('currency.lbp') },
  { value: 'LSL', label: t('currency.lsl') },
  { value: 'LRD', label: t('currency.lrd') },
  { value: 'LYD', label: t('currency.lyd') },
  { value: 'CHF', label: t('currency.chf') },
  { value: 'MOP', label: t('currency.mop') },
  { value: 'MKD', label: t('currency.mkd') },
  { value: 'MGA', label: t('currency.mga') },
  { value: 'MWK', label: t('currency.mwk') },
  { value: 'MYR', label: t('currency.myr') },
  { value: 'MVR', label: t('currency.mvr') },
  { value: 'MRU', label: t('currency.mru') },
  { value: 'MUR', label: t('currency.mur') },
  { value: 'MXN', label: t('currency.mxn') },
  { value: 'MXV', label: t('currency.mxv') },
  { value: 'MDL', label: t('currency.mdl') },
  { value: 'MNT', label: t('currency.mnt') },
  { value: 'MAD', label: t('currency.mad') },
  { value: 'MZN', label: t('currency.mzn') },
  { value: 'MMK', label: t('currency.mmk') },
  { value: 'NAD', label: t('currency.nad') },
  { value: 'NPR', label: t('currency.npr') },
  { value: 'NGN', label: t('currency.ngn') },
  { value: 'OMR', label: t('currency.omr') },
  { value: 'PKR', label: t('currency.pkr') },
  { value: 'PAB', label: t('currency.pab') },
  { value: 'PGK', label: t('currency.pgk') },
  { value: 'PYG', label: t('currency.pyg') },
  { value: 'PEN', label: t('currency.pen') },
  { value: 'PHP', label: t('currency.php') },
  { value: 'PLN', label: t('currency.pln') },
  { value: 'QAR', label: t('currency.qar') },
  { value: 'RON', label: t('currency.ron') },
  { value: 'RUB', label: t('currency.rub') },
  { value: 'RWF', label: t('currency.rwf') },
  { value: 'SHP', label: t('currency.shp') },
  { value: 'RSD', label: t('currency.rsd') },
  { value: 'SCR', label: t('currency.scr') },
  { value: 'SLE', label: t('currency.sle') },
  { value: 'SGD', label: t('currency.sgd') },
  { value: 'XSU', label: t('currency.xsu') },
  { value: 'SBD', label: t('currency.sbd') },
  { value: 'SOS', label: t('currency.sos') },
  { value: 'ZAR', label: t('currency.zar') },
  { value: 'SSP', label: t('currency.ssp') },
  { value: 'LKR', label: t('currency.lkr') },
  { value: 'SDG', label: t('currency.sdg') },
  { value: 'SRD', label: t('currency.srd') },
  { value: 'SEK', label: t('currency.sek') },
  { value: 'CHE', label: t('currency.che') },
  { value: 'CHW', label: t('currency.chw') },
  { value: 'SYP', label: t('currency.syp') },
  { value: 'TWD', label: t('currency.twd') },
  { value: 'TJS', label: t('currency.tjs') },
  { value: 'TZS', label: t('currency.tzs') },
  { value: 'THB', label: t('currency.thb') },
  { value: 'TOP', label: t('currency.top') },
  { value: 'TTD', label: t('currency.ttd') },
  { value: 'TND', label: t('currency.tnd') },
  { value: 'TRY', label: t('currency.try') },
  { value: 'TMT', label: t('currency.tmt') },
  { value: 'UGX', label: t('currency.ugx') },
  { value: 'UAH', label: t('currency.uah') },
  { value: 'AED', label: t('currency.aed') },
  { value: 'USN', label: t('currency.usn') },
  { value: 'UYU', label: t('currency.uyu') },
  { value: 'UYI', label: t('currency.uyi') },
  { value: 'UYW', label: t('currency.uyw') },
  { value: 'UZS', label: t('currency.uzs') },
  { value: 'VUV', label: t('currency.vuv') },
  { value: 'VES', label: t('currency.ves') },
  { value: 'VED', label: t('currency.ved') },
  { value: 'VND', label: t('currency.vnd') },
  { value: 'YER', label: t('currency.yer') },
  { value: 'ZMW', label: t('currency.zmw') },
  { value: 'ZWG', label: t('currency.zwg') },
  { value: 'XBA', label: t('currency.xba') },
  { value: 'XBB', label: t('currency.xbb') },
  { value: 'XBC', label: t('currency.xbc') },
  { value: 'XBD', label: t('currency.xbd') },
  { value: 'XTS', label: t('currency.xts') },
  { value: 'XXX', label: t('currency.xxx') },
  { value: 'XAU', label: t('currency.xau') },
  { value: 'XPD', label: t('currency.xpd') },
  { value: 'XPT', label: t('currency.xpt') },
  { value: 'XAG', label: t('currency.xag') },
];
